import PropertyCard from "./PropertyCard";

const SchemaSection = ({
  title,
  schema,
  side,
  onConnect,
  onRemoveConnection,
  connections,
  rightSchema,
  activeConnection,
  checkedAttributes,
  onCheckAttribute,
  comments,
  onCommentChange,
}) => {
  // Si le schéma est un objet avec une seule clé, utiliser les propriétés de cet objet
  const schemaProperties =
    schema.properties || Object.values(schema)[0].properties;
  const schemaTitle = title || Object.keys(schema)[0];
  const requiredFields =
    schema.required || Object.values(schema)[0].required || [];

  // Trier les propriétés selon le côté
  const sortedProperties = Object.entries(schemaProperties).sort(
    ([nameA, propA], [nameB, propB]) => {
      if (side === "right") {
        // Pour la colonne de droite : références à la fin
        const aIsRef = propA.$ref !== undefined;
        const bIsRef = propB.$ref !== undefined;
        if (aIsRef === bIsRef) return 0;
        return aIsRef ? 1 : -1;
      } else {
        // Pour la colonne de gauche : required en premier
        const aIsRequired = requiredFields.includes(nameA);
        const bIsRequired = requiredFields.includes(nameB);
        if (aIsRequired === bIsRequired) return 0;
        return aIsRequired ? -1 : 1;
      }
    }
  );

  return (
    <div className="mb-4">
      <h3 className="h5 mb-2 text-white">{schemaTitle}</h3>
      <div className="schema-properties  px-1 pt-2">
        {sortedProperties.map(([name, property]) => {
          const fullId = `${schemaTitle}/${name}`;
          const isRequired = requiredFields.includes(name);

          // Pour la colonne de droite, on vérifie si l'élément est déjà lié
          if (side === "right") {
            const isLinked = connections?.some(
              (conn) => conn.endName === fullId
            );
            if (isLinked) return null; // Ne pas afficher l'élément s'il est déjà lié
          }

          // Vérifier si la propriété a une référence
          const hasReference = property.$ref !== undefined;
          const isConnectable = side === "right" || !hasReference;

          return (
            <PropertyCard
              key={fullId}
              name={name}
              schemaTitle={schemaTitle}
              property={property}
              side={side}
              onConnect={(element) => onConnect(fullId, element)}
              onRemoveConnection={onRemoveConnection}
              isConnectable={isConnectable}
              connections={connections}
              rightSchema={rightSchema}
              activeConnection={activeConnection}
              isRequired={isRequired}
              isChecked={checkedAttributes[`${schemaTitle}/${name}`]}
              onCheckAttribute={(isChecked) =>
                onCheckAttribute(`${schemaTitle}/${name}`, isChecked)
              }
              comment={comments?.[`${schemaTitle}/${name}`]}
              onCommentChange={(comment) =>
                onCommentChange(`${schemaTitle}/${name}`, comment)
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default SchemaSection;
